import { ICommonTranslations } from '@/translations/default/common';

const common: Partial<ICommonTranslations> = {
  product_interactions: 'Interacciones de productos',
};

export default common;
